import { __rest, __assign } from 'tslib';
import React, { useContext, useEffect } from 'react';
import cn from 'classnames';
import { BaseModalContext } from '@alfalab/core-components-base-modal/esm';
import { NavigationBar } from '@alfalab/core-components-navigation-bar/esm';

var styles = {"headerWrapper":"bottom-sheet__headerWrapper_171ua","hasContent":"bottom-sheet__hasContent_171ua","header":"bottom-sheet__header_171ua","sticky":"bottom-sheet__sticky_171ua","highlighted":"bottom-sheet__highlighted_171ua","justifyEnd":"bottom-sheet__justifyEnd_171ua","addon":"bottom-sheet__addon_171ua","addonFixed":"bottom-sheet__addonFixed_171ua","title":"bottom-sheet__title_171ua","titleCenter":"bottom-sheet__titleCenter_171ua","titleLeft":"bottom-sheet__titleLeft_171ua","trimTitle":"bottom-sheet__trimTitle_171ua"};
require('./index.css')

var Header = function (_a) {
    var _b;
    var className = _a.className, sticky = _a.sticky, headerRef = _a.headerRef, headerOffset = _a.headerOffset, title = _a.title, children = _a.children, restProps = __rest(_a, ["className", "sticky", "headerRef", "headerOffset", "title", "children"]);
    var _c = useContext(BaseModalContext), setHeaderOffset = _c.setHeaderOffset, setHasHeader = _c.setHasHeader, headerHighlighted = _c.headerHighlighted, onClose = _c.onClose;
    useEffect(function () {
        setHeaderOffset(headerOffset);
    }, [headerOffset, setHeaderOffset]);
    useEffect(function () {
        setHasHeader(true);
    }, [setHasHeader]);
    var hasContent = Boolean(title || children);
    return (React.createElement(NavigationBar, __assign({}, restProps, { ref: headerRef, title: title, onClose: onClose, sticky: sticky, view: 'mobile', className: cn(styles.headerWrapper, className, (_b = {},
            _b[styles.highlighted] = hasContent && headerHighlighted && sticky,
            _b[styles.sticky] = sticky,
            _b[styles.hasContent] = hasContent,
            _b)), contentClassName: cn(styles.title) }), children));
};

export { Header };
